import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import Chevron from 'components/molecules/SurveyCard/assets/Chevron';
import UserIcon from './assets/user-icon.svg';
import classes from './MoreSurveysBanner.module.scss';
import { useMoreSurveysBannerQuery } from './useMoreSurveysBannerQuery';
import { useMoreSurveysBannerQuery_profileUrlRef$key } from './__generated__/useMoreSurveysBannerQuery_profileUrlRef.graphql';

export type Props = {
  profileUrlRef: useMoreSurveysBannerQuery_profileUrlRef$key;
  className: string;
};

export default function MoreSurveysBanner({ profileUrlRef, className }: Props) {
  const data = useMoreSurveysBannerQuery(profileUrlRef);

  return data.profilerUrl ? (
    <Card className={clsx(classes.root, className)} isLink>
      <A href={data.profilerUrl} className={classes.innerLink}>
        <div className={classes.userRow}>
          <Txt className={classes.userName} skipTranslation>
            {data.userData?.firstName ?? 'Hi'}
          </Txt>
          <UserIcon className={classes.iconImage} />
        </div>
        <Txt className={classes.text}>
          We need to get to know you a little better so that we can match you to surveys that best
          suit you.
        </Txt>
        <div className={classes.cta}>
          <Txt className={classes.matchMe}>Match me to surveys</Txt>
          <span className={classes.duration}>
            <Txt>
              <Txt className={classes.minutes} skipTranslation>
                {{ duration: 3 }}
              </Txt>{' '}
              <span className={classes.units}>mins</span>
            </Txt>
            <Chevron className={classes.chevron} />
          </span>
        </div>
      </A>
    </Card>
  ) : null;
}
